// extracted by mini-css-extract-plugin
export default {"share-button-container":"HZYYS","share-button":"x_KV9","twitter":"n9sNG"};